import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../components/ui/Button/Buttons';
import { PATHS } from '../constants/Paths.constants';
import { AccessDeniedIcon } from '../icons/SvgIcons';

/**
 * Terminal state: the signed-in user's token resolves to no organization.
 * Signing in again returns the identical token, so sign-out is the only exit.
 */
export function NoOrganization() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen min-w-screen flex items-center justify-center bg-white">
      <div className="flex flex-row gap-6 text-left">
        {AccessDeniedIcon()}
        <div className="flex flex-col items-start w-[480px] pl-6">
          <h1 className="text-[30px] leading-[36px] font-bold text-purple-900">
            No organization assigned
          </h1>
          <p className="text-base text-gray-500 mb-10">
            Your account isn’t linked to an organization. Ask your administrator
            to invite you.
          </p>
          <PrimaryButton onClick={() => navigate(PATHS.LOGOUT)}>
            Sign out
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
